import { defineComponent } from 'vue'
import { useLocalSettingsStore } from '@/stores/localSettings'
import { useStore } from 'vuex'

export function promptLocalSettings (dialog) {
  const DialogContent = defineComponent({
    setup () {
      const localSettingsStore = useLocalSettingsStore()
      const store = useStore()

      return () => <div>
        <div class="tw:flex tw:items-start">
          <Checkbox v-model={localSettingsStore.defaultCrossIndexRetroactive} inputId="defaultCrossIndexRetroactive" size="small" binary class="tw:mt-1" />
          <label class="tw:ml-2" for="defaultCrossIndexRetroactive">Default make changes to cross-indexed user fields retroactive</label>
        </div>
        { store.getters.costingEnabled &&
        <div class="tw:flex tw:items-center tw:mt-3">
          <Checkbox v-model={localSettingsStore.orgDisableCostingPerms} inputId="orgDisableCostingPerms" size="small" binary />
          <label class="tw:ml-2" for="orgDisableCostingPerms">Disable costing permission filtering</label>
        </div>
        }
        { store.getters.enhancedCostingEnabled &&
        <div class="tw:flex tw:items-center tw:mt-3">
          <Checkbox v-model={localSettingsStore.orgDisableCostingWorkLabelPerms} inputId="orgDisableCostingWorkLabelPerms" size="small" binary />
          <label class="tw:ml-2" for="orgDisableCostingWorkLabelPerms">Disable costing permission work label filtering</label>
        </div>
        }
      </div>
    }
  })

  const _dialogRef = dialog.open(DialogContent, {
    props: {
      header: 'Local Settings',
      style: {
          width: '375px',
      },
      modal: true,
      dismissableMask: true
    }
  })
}
